import axiosClient from "../../common/axios/axiosConfig";
import { ErrorToast } from "../../common/toasts/toasts";
import useQuery from "../../utils/useQuery";
import { IMessage } from "../../common/interfaces/IMessage";

export const sendMessage = async (
  formData: FormData,
): Promise<{ success: boolean; data: IMessage | null; message: string }> => {
  const token = useQuery().get("token");

  try {
    const response = await axiosClient.post<IMessage[]>(`/chat/messages`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    });

    const lastMessage = response.data?.slice(-1)[0] || null;

    return {
      success: true,
      data: lastMessage,
      message: "Mensagem enviada com sucesso",
    };
  } catch (error: any) {
    ErrorToast.fire({
      text: "Erro ao enviar mensagem",
    });

    return {
      success: false,
      data: null,
      message: error.response?.data?.message || "Erro ao enviar mensagem",
    };
  }
};


